module.exports = __webpack_public_path__ + "img/Bitmap.e9d30cf7.png";